import { createContext } from "react";

const PackageContext = createContext('sidebar');

export default PackageContext;